<div class="app-modal-title">
  <div class="title">Logger</div>
  <div class="glyphicons glyphicons-remove" (click)="cancel()"></div>
</div>

<div class="app-modal-content">
  <div>
    <div *ngFor="let process of processes;">
      <div class="process-header">
        <div class="process-title">
          <div>{{checkIsLive(process) ? process.type : process.type}}</div>
          <div [ngClass]="{'spinner-arrow': checkIsLive(process)}"></div>
        </div>
        <div class="process-right-panel">
          <div class="process-date" [hidden]="checkIsLive(process)">{{process.endTime}}</div>
          <button [disabled]="process.clickedCancel" (click)="cancelProcess(process)" class="button-general  button-general-no process-cancel-button" [hidden]="!checkIsLive(process)" autofocus="false">Cancel</button>
          <button [hidden]="checkIsLive(process)||process.status==='Canceled'" class="button-general" (click)="viewLog(process)">View</button>
          <i *ngIf="process.status==='Canceled'" class="glyphicons glyphicons-remove" style="color:red;" title="Process is canceled."></i>
        </div>
        
      </div>
      <div class="log-message" [hidden]="!checkIsLive(process)">
        <div class="message-list">
          <div *ngFor="let message of process.messages;" [ngClass]="{'err-msg': message.type==='err'}">
            <div>{{message.message}}</div>
          </div>
        </div>
      </div>
		</div>
  </div>
</div>